import {
	Validator
}
	from 'vee-validate'
import CryptoJS from 'crypto-js'
import VueElementLoading from 'vue-element-loading'
import rtoApis from '../../../views/components/rtogrn/rtogrn.js'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import VueBarcode from 'vue-barcode'
import Printd from 'printd'
import Vue from 'vue';
import {
	WebCam
} from "vue-web-cam"
import DatePicker from 'vue2-datepicker'
import common_helper from '../../../common_helper'
export default {
	name: 'rtogrn',
	components: {
		WebCam,
		VueElementLoading,
		Multiselect,
		'barcode': VueBarcode,
		DatePicker
	},

	data: function () {
		return {
			drData: {
				invReferenceID: "",
				mrp: "",
				expiryDate: ""
			},
			isInitiated: 0,
			isOrderMapped: 0,
			imageDescription: "",
			cameraSection: false,
			fileSection: false,
			isLoading1: false,
			isLoading2: false,
			isLoading3: false,
			isLoading4: false,
			isLoading5: false,
			isLoading6: false,
			isLoading7: false,
			productUploadLabel: false,
			productUploadImage1: false,
			productUploadImage2: false,
			productUploadImage3: false,
			imageCaptured: false,
			imageRefId: "",
			uploadPictures: false,
			token: "",
			user_type: "",
			listWarehouseData: [],
			listClientData: [],
			isRTV: false,
			isRTO: true,
			isValidAWB: false,
			isOrderIdUpdated: false,
			updatedOrderId: "",
			systemLoginCheck: false,
			showProductQcDetails: true,
			isProductReject: false,
			showQCButton: false,
			imageType: "",
			showOrderIdInput: false,
			accordianTab: {
				1: true,
				2: false,
				3: true,
				4: false,
				5: false
			},
			globalObject: {
				userEmail: "",
				warehouseId: "",
				clientId: "",
				awbNo: "",
				merchantName: "",
				orderID: "",
				orderDate: "",
				whReceivedDate: "",
				transporter: "",
				productDetails: [],
				productDetailsCount: 0,
				extraProductDetails: [],
				extraProductDetailsCount: 0,
				externalProductDetails: [],
				externalProductDetailsCount: 0,
				rtoId: "",
				srId: "",
				productId: "",
				orderProduct: false,
				extraProduct: false,
				excessProduct: false,
				rejectList: [],
				rejectReason: "",
				expiryDate: "",
				scanProductDetails: {
					clientproductid: "",
					productid: "",
					productname: "",
					productdescription: "",
					productimage: "",
					productType: "",
					expirycontrolled: "",
					nocontrol: "",
				},
				isThreshold: false,
				thresholdValue: 0
			},
			productUploadLabelUpload: false,
			productUploadImage1Upload: false,
			productUploadImage2Upload: false,
			productUploadImage3Upload: false,
			productUploadLabelUrl: "",
			productUploadImage1Url: "",
			productUploadImage2Url: "",
			productUploadImage3Url: "",
			qcDoneReject: false,
			viewImage: false,
			imageUrl: "",
			qcDoneFlag: false,
			showExpiryDate: false,
			cameralist: '',
			cameras: [],
			selectFirstDevice: true,
			deviceId: null,
			playsinline: false,
			notcheckbtn: false,
			autoplay: true,
			screenshotFormat: "image/jpeg",
			isBoxchanged:false,
			isRefurbished:false,
			showrefurbished:false
		}
	},

	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
		var plaintext = bytes.toString(CryptoJS.enc.Utf8)
		var userdetail = JSON.parse(plaintext)
		var userToken = window.localStorage.getItem('userToken')
		this.token = userToken.replace(/"/g, '')
		this.globalObject.userEmail = userdetail.email
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.user_type = userdetail.utype
		switch (this.user_type) {
			case 'system_user':
				// this.getClientList()
				this.systemLoginCheck = true
				break

			case 'client_user':
				this.getClientList()
				this.$alert("Unauthorised user, Please contact your system admin")
				break

			case 'warehouse_user':
				// this.getClientList()
				this.globalObject.warehouseId = userdetail.warehouseid
				break

			default:
				this.$alert("Unauthorised user, Please contact your system admin")
				break
		}
	},
	methods: {
		disabledAccept(){
			this.isRefurbished = document.getElementById("isRefurbished1").checked
			this.isBoxchanged = document.getElementById("boxchange1").checked
		},
		cameraSelected() {
			this.checkbtn = false
			this.notcam = false
			this.notcheckbtn = true
			this.$refs.cameraImage.changeCamera(this.cameralist)
		},
		camerass(camlist) {
			this.cameras = camlist
		},
		expandAll() {
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		resetForm() {
			this.$nextTick(() => {
				this.closeAllLoader()
				for (var key in this.accordianTab) {
					this.accordianTab[key] = false;
					if (key == 1) {
						this.accordianTab[key] = true;
					}
				}
				if (this.systemLoginCheck) {
					this.globalObject.warehouseId = ""
				}
				if (this.globalObject.awbNo != "") {
					Vue.nextTick(() => {
					document.getElementById('awbNo').disabled = false
					// document.getElementById('productId').disabled = false
					// document.getElementById('productId').value = null
					document.getElementById('awbNo').value = null
					})
				}
				this.showOrderIdInput = false
				this.imageDescription = ""
				this.drData.invReferenceID = ""
				this.drData.mrp = ""
				this.drData.expiryDate = ""
				this.isInitiated = 0
				this.isOrderMapped = 0
				this.globalObject.clientId = ""
				this.globalObject.awbNo = ""
				this.globalObject.merchantName = ""
				this.globalObject.orderID = ""
				this.globalObject.orderDate = ""
				this.globalObject.whReceivedDate = ""
				this.globalObject.transporter = ""
				this.globalObject.expiryDate = ""
				this.globalObject.isThreshold = false
				this.globalObject.thresholdValue = 0
				this.globalObject.productDetails = []
				this.globalObject.extraProductDetails = []
				this.globalObject.externalProductDetails = []
				this.globalObject.rtoId = ""
				this.globalObject.srId = ""
				this.isValidAWB = false
				this.showProductQcDetails = false
				this.isProductReject = false
				this.globalObject.productDetailsCount = 0
				this.globalObject.extraProductDetailsCount = 0
				this.globalObject.externalProductDetailsCount = 0
				this.globalObject.productId = ""
				this.globalObject.orderProduct = false
				this.globalObject.extraProduct = false
				this.globalObject.excessProduct = false
				this.globalObject.scanProductDetails.clientproductid = ""
				this.globalObject.scanProductDetails.productid = ""
				this.globalObject.scanProductDetails.productname = ""
				this.globalObject.scanProductDetails.productdescription = ""
				this.globalObject.scanProductDetails.productimage = ""
				this.globalObject.scanProductDetails.productType = ""
				this.globalObject.scanProductDetails.expirycontrolled = ""
				this.globalObject.scanProductDetails.nocontrol = ""
				this.globalObject.rejectList = []
				this.globalObject.rejectReason = ""
				this.showQCButton = false
				this.uploadPictures = false
				this.productUploadLabel = false
				this.productUploadImage1 = false
				this.productUploadImage2 = false
				this.productUploadImage3 = false
				this.cameraSection = false
				this.fileSection = false
				this.file = null
				this.cameraImage = null
				this.imageRefId = ""
				this.imageCaptured = false
				this.imageType = ""
				this.productUploadLabelUpload = false
				this.productUploadImage1Upload = false
				this.productUploadImage2Upload = false
				this.productUploadImage3Upload = false
				this.productUploadLabelUrl = ""
				this.productUploadImage1Url = ""
				this.productUploadImage2Url = ""
				this.productUploadImage3Url = ""
				this.qcDoneReject = false
				this.viewImage = false
				this.imageUrl = ""
				this.qcDoneFlag = false
				this.showExpiryDate = false
				this.isOrderIdUpdated = false
				this.updatedOrderId = ""
				this.$validator.reset()

			})
		},

		resetForScan() {
			this.drData.invReferenceID = ""
			this.drData.mrp = ""
			this.drData.expiryDate = ""
			this.showOrderIdInput = false
			this.imageDescription = ""
			this.isInitiated = 0
			this.isOrderMapped = 0
			this.globalObject.merchantName = ""
			this.globalObject.orderID = ""
			this.globalObject.orderDate = ""
			this.globalObject.whReceivedDate = ""
			this.globalObject.transporter = ""
			this.globalObject.expiryDate = ""
			this.globalObject.isThreshold = false
			this.globalObject.thresholdValue = 0
			this.globalObject.productDetails = []
			this.globalObject.extraProductDetails = []
			this.globalObject.externalProductDetails = []
			this.globalObject.rtoId = ""
			this.globalObject.srId = ""
			this.isValidAWB = false
			this.showProductQcDetails = false
			this.isProductReject = false
			this.globalObject.productDetailsCount = 0
			this.globalObject.extraProductDetailsCount = 0
			this.globalObject.externalProductDetailsCount = 0
			this.globalObject.productId = ""
			this.globalObject.orderProduct = false
			this.globalObject.extraProduct = false
			this.globalObject.excessProduct = false
			this.globalObject.scanProductDetails.clientproductid = ""
			this.globalObject.scanProductDetails.productid = ""
			this.globalObject.scanProductDetails.productname = ""
			this.globalObject.scanProductDetails.productdescription = ""
			this.globalObject.scanProductDetails.productimage = ""
			this.globalObject.scanProductDetails.productType = ""
			this.globalObject.scanProductDetails.expirycontrolled = ""
			this.globalObject.scanProductDetails.nocontrol = ""
			this.globalObject.rejectList = []
			this.globalObject.rejectReason = ""
			this.showQCButton = false
			this.uploadPictures = false
			this.productUploadLabel = false
			this.productUploadImage1 = false
			this.productUploadImage2 = false
			this.productUploadImage3 = false
			this.cameraSection = false
			this.fileSection = false
			this.file = null
			this.cameraImage = null
			this.imageRefId = ""
			this.imageCaptured = false
			this.imageType = ""
			this.productUploadLabelUpload = false
			this.productUploadImage1Upload = false
			this.productUploadImage2Upload = false
			this.productUploadImage3Upload = false
			this.productUploadLabelUrl = ""
			this.productUploadImage1Url = ""
			this.productUploadImage2Url = ""
			this.productUploadImage3Url = ""
			this.qcDoneReject = false
			this.viewImage = false
			this.imageUrl = ""
			this.qcDoneFlag = false
			this.showExpiryDate = false
			this.isOrderIdUpdated = false
			this.updatedOrderId = ""
			this.$validator.reset()
		},

		dateFormatDetail(date) {
			if (!date) return ''
			return moment(date).format('LLLL')
		},

		toggleCheck(tabid) {
			for (var key in this.accordianTab) {
				if (tabid != key) {
					this.accordianTab[key] = false
				}
			}
		},

		// async getWarehouseList() {
		// 	try {
		// 		this.isLoading1 = true
		// 		let inputPayload = {
		// 			clientid: this.globalObject.clientId
		// 		}
		// 		let result = await rtoApis.getWarehouseList(this.token, inputPayload)
		// 		this.listWarehouseData = result.data.data
		// 		this.isLoading1 = false
		// 	} catch (err) {
		// 		console.log(err)
		// 		this.closeAllLoader()
		// 	}
		// },

		closeAllLoader() {
			this.isLoading1 = false
			this.isLoading2 = false
			this.isLoading3 = false
			this.isLoading4 = false
			this.isLoading5 = false
			this.isLoading6 = false
			this.isLoading7 = false
		},

		// async getClientList() {
		// 	try {
		// 		if (window.localStorage.getItem("clientList") !== null) {
		// 			var clientListEncrypt = window.localStorage.getItem('clientList');
		// 			var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 			var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 			this.listClientData = JSON.parse(plaintextclient);
		// 		} else {
		// 			let inputPayload = {
		// 				warehouseid: this.globalObject.warehouseId,
		// 			}
		// 			this.isLoading1 = true
		// 			let result = await rtoApis.getClientList(this.token, inputPayload)
		// 			this.listWarehouseData = result.data.data
		// 			this.isLoading1 = false
		// 		}
		// 	} catch (err) {
		// 		console.log(err)
		// 		this.closeAllLoader()
		// 	}
		// },

		// clientSelected() {
		// 	if (this.systemLoginCheck) {
		// 		this.getWarehouseList()
		// 	}
		// },

		tabChanged(obj) {
			this.resetForm()
			if (obj == 1) {
				this.isRTV = false
				this.isRTO = true
			} else {
				this.isRTV = true
				this.isRTO = false
			}

		},

		awbEntered() {
			if (!this.globalObject.awbNo) {
				this.$alert("Please scan AWB no")
			} else {
				this.scanAwbNo()
			}
		},

		async scanAwbNo() {
			try {
				if (localStorage.getItem("selectedClient") == 'undefined') {
					this.WarehouseErr = this.$t('common.clientError');
					this.$alertify.error(this.$t('common.clientError'))
					return false;
				  }
				  if (localStorage.getItem("selectedWarehouse") == 'undefined') {
					this.WarehouseErr = this.$t('common.warehouseError');
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;
				  }
				this.resetForScan()
				this.isLoading1 = true
				let inputPayload = {
					clientid: this.client,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					awbno: this.globalObject.awbNo.trim(),
					useremail:this.globalObject.userEmail,
				}
				if (this.isRTO) {
					let result = await rtoApis.getDetailsForRTOGRC(this.token, inputPayload)
					this.isLoading1 = false
					if (result.data.errorCode == 0) {
						this.isValidAWB = true
						document.getElementById('awbNo').disabled = true
						for (var key in this.accordianTab) {
							this.accordianTab[key] = true;
						}
						let data = result.data.data
						data.rtodata.forEach((el) => {
							this.globalObject.productDetails.push({
								productid: el.productid,
								quantity: el.quantity,
								productname: el.productname,
								eancode: el.eancode,
								status: el.status,
								productqty: el.productqty,
								total_quantity: Number(el.accepted_qty) + Number(el.rejected_qty),
								accepted_qty: el.accepted_qty,
								rejected_qty: el.rejected_qty
							})
						})
						this.globalObject.rejectList = data.reasonResult
						this.globalObject.productDetailsCount = data.rtodata[0].total_quantity
						this.globalObject.rtoId = data.rtodata[0].rtoid
						this.globalObject.merchantName = data.rtodata[0].merchantname
						this.globalObject.orderID = data.rtodata[0].orderid
						this.globalObject.orderDate = data.rtodata[0].orderdaate
						this.globalObject.whReceivedDate = data.rtodata[0].createddatetime
						this.globalObject.transporter = data.rtodata[0].transporter
						this.globalObject.extraProductDetails = data.extraProduct
						this.globalObject.externalProductDetails = data.excessProduct
						this.qcDoneFlag = data.qcdoneflag
						this.globalObject.extraProductDetailsCount = 0
						this.globalObject.extraProductDetails.forEach((el) => {
							this.globalObject.extraProductDetailsCount = this.globalObject.extraProductDetailsCount + Number(el.total_qty)
						})
						this.globalObject.externalProductDetailsCount = 0
						this.globalObject.externalProductDetails.forEach((el) => {
							this.globalObject.externalProductDetailsCount = this.globalObject.externalProductDetailsCount + Number(el.total_qty)
						})
					} else {
						this.isValidAWB = false
						for (var key in this.accordianTab) {
							if (key != 1) {
								this.accordianTab[key] = false;
							}
						}
						this.globalObject.rejectList = []
						this.globalObject.productDetails = []
						this.globalObject.productDetailsCount = 0
						this.globalObject.rtoId = ""
						this.globalObject.srId = ""
						this.globalObject.merchantName = ""
						this.globalObject.orderID = ""
						this.globalObject.orderDate = ""
						this.globalObject.whReceivedDate = ""
						this.globalObject.transporter = ""
						this.globalObject.expiryDate = ""
						this.globalObject.isThreshold = false
						this.globalObject.thresholdValue = 0
						this.globalObject.extraProductDetails = ""
						this.globalObject.externalProductDetails = ""
						this.globalObject.extraProductDetailsCount = 0
						this.globalObject.extraProductDetailsCount = 0
						this.globalObject.externalProductDetailsCount = 0
						this.globalObject.externalProductDetailsCount = 0
						let awb = this.globalObject.awbNo
						document.getElementById('awbNo').value = ""
						this.globalObject.awbNo = ""
						this.$alert(result.data.msg, awb)
					}
				} else {
					this.isInitiated = 0
					this.isOrderMapped = 0
					let result = await rtoApis.getDetailsForSRGRC(this.token, inputPayload)
					this.isLoading1 = false
					if (result.data.errorCode == 0) {
						let data = result.data.data
						this.isInitiated = data.isinitiated
						this.isOrderMapped = data.isordermapped
						this.qcDoneFlag = data.qcdoneflag
						if (data.isinitiated > 0 && data.isordermapped > 0) {
							this.isOrderIdUpdated = data.srdata[0].isorderidupdated === 1 ? true : false;
							this.globalObject.srId = data.srdata[0].srid
							this.isValidAWB = true
							document.getElementById('awbNo').disabled = true
							for (var key in this.accordianTab) {
								this.accordianTab[key] = true;
							}
							this.globalObject.extraProductDetails = data.extraProduct
							this.globalObject.externalProductDetails = data.excessProduct
							this.globalObject.extraProductDetailsCount = 0
							this.globalObject.extraProductDetails.forEach((el) => {
								this.globalObject.extraProductDetailsCount = this.globalObject.extraProductDetailsCount + Number(el.total_qty)
							})
							this.globalObject.externalProductDetailsCount = 0
							this.globalObject.externalProductDetails.forEach((el) => {
								this.globalObject.externalProductDetailsCount = this.globalObject.externalProductDetailsCount + Number(el.total_qty)
							})
							data.srdata.forEach((el) => {
								this.globalObject.productDetails.push({
									productid: el.productid,
									quantity: el.quantity,
									productname: el.productname,
									eancode: el.eancode,
									status: el.status,
									productqty: el.productqty,
									total_quantity: Number(el.accepted_qty) + Number(el.rejected_qty),
									accepted_qty: el.accepted_qty,
									rejected_qty: el.rejected_qty
								})
							})
							this.globalObject.rejectList = data.reasonResult
							this.globalObject.productDetailsCount = 0
							this.globalObject.productDetails.forEach((el) => {
								this.globalObject.productDetailsCount = this.globalObject.productDetailsCount + Number(el.productqty)
							})
							this.globalObject.merchantName = data.srdata[0].merchantname
							this.globalObject.orderID = data.srdata[0].orderid
							this.globalObject.orderDate = data.srdata[0].orderdate
							this.globalObject.whReceivedDate = data.srdata[0].createddate
							this.globalObject.transporter = data.srdata[0].couriercompany
							this.updatedOrderId = this.globalObject.orderID
							if(!this.isOrderIdUpdated) this.$alert(this.$t('createGRN.initiatedReturnOrder')+` ${this.globalObject.orderID} `+this.$t('createGRN.mapped'));
						} else {
							if (this.isOrderMapped > 0) {
								this.globalObject.rejectList = data.reasonResult
								this.globalObject.srId = data.srdata[0].srid
								document.getElementById('awbNo').disabled = true
								this.showOrderIdInput = false
								this.isValidAWB = true

								for (var key in this.accordianTab) {
									this.accordianTab[key] = true;
								}
								this.globalObject.extraProductDetails = data.extraProduct
								this.globalObject.externalProductDetails = data.excessProduct
								this.globalObject.extraProductDetailsCount = 0
								this.globalObject.extraProductDetails.forEach((el) => {
									this.globalObject.extraProductDetailsCount = this.globalObject.extraProductDetailsCount + Number(el.total_qty)
								})
								this.globalObject.externalProductDetailsCount = 0
								this.globalObject.externalProductDetails.forEach((el) => {
									this.globalObject.externalProductDetailsCount = this.globalObject.externalProductDetailsCount + Number(el.total_qty)
								})
								data.srdata.forEach((el) => {
									this.globalObject.productDetails.push({
										productid: el.productid,
										quantity: el.quantity,
										productname: el.productname,
										eancode: el.eancode,
										status: el.status,
										productqty: el.productqty,
										total_quantity: Number(el.accepted_qty) + Number(el.rejected_qty),
										accepted_qty: el.accepted_qty,
										rejected_qty: el.rejected_qty
									})
								})
								this.globalObject.productDetailsCount = 0
								this.globalObject.productDetails.forEach((el) => {
									this.globalObject.productDetailsCount = this.globalObject.productDetailsCount + Number(el.productqty)
								})
								this.globalObject.merchantName = data.srdata[0].merchantname
								this.globalObject.orderID = data.srdata[0].orderid
								this.globalObject.orderDate = data.srdata[0].orderdate
								this.globalObject.whReceivedDate = data.srdata[0].createddate
								this.globalObject.transporter = data.srdata[0].couriercompany
								this.$alert(result.data.msg)
							} else {
								this.globalObject.rejectList = data.reasonResult
								this.globalObject.srId = data.srdata[0].srid
								document.getElementById('awbNo').disabled = true
								this.showOrderIdInput = true
								this.$alert(result.data.msg)
							}
						}
					} else {
						this.isValidAWB = false
						for (var key in this.accordianTab) {
							if (key != 1) {
								this.accordianTab[key] = false;
							}
						}
						this.globalObject.srId = ""
						this.globalObject.rejectList = []
						this.globalObject.productDetails = []
						this.globalObject.productDetailsCount = 0
						this.globalObject.rtoId = ""
						this.globalObject.merchantName = ""
						this.globalObject.orderID = ""
						this.globalObject.orderDate = ""
						this.globalObject.whReceivedDate = ""
						this.globalObject.transporter = ""
						this.globalObject.expiryDate = ""
						this.globalObject.isThreshold = false
						this.globalObject.thresholdValue = 0
						this.globalObject.extraProductDetails = ""
						this.globalObject.externalProductDetails = ""
						this.globalObject.extraProductDetailsCount = 0
						this.globalObject.extraProductDetailsCount = 0
						this.globalObject.externalProductDetailsCount = 0
						this.globalObject.externalProductDetailsCount = 0
						let awb = this.globalObject.awbNo
						document.getElementById('awbNo').value = ""
						this.globalObject.awbNo = ""
						this.$alert(result.data.msg, awb)
					}
				}
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		},

		async orderIdEntered() {
			try {
				if (!this.globalObject.orderID) {
					this.$alert("Enter order ID")
					return false
				}
				let orderID = this.globalObject.orderID
				this.isLoading1 = true
				let inputPayload = {
					clientid: this.client,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.globalObject.orderID.trim()
				}
				let result = await rtoApis.validateOrderIdForSRGRC(this.token, inputPayload)
				this.isLoading1 = false
				if (result.data.errorCode == 0) {
					if (result.data.srcount >= 1) {
						this.$alert(this.$t('createGRN.rvpAlreadyMarked'))
					}
					this.showOrderIdInput = false
					this.isValidAWB = true
					for (var key in this.accordianTab) {
						this.accordianTab[key] = true;
					}
					this.globalObject.extraProductDetailsCount = 0
					this.globalObject.externalProductDetailsCount = 0
					this.globalObject.productDetailsCount = 0
					this.globalObject.extraProductDetails = []
					this.globalObject.externalProductDetails = []
					this.globalObject.productDetails = []
					this.globalObject.merchantName = ""
					this.globalObject.orderDate = ""
					this.globalObject.whReceivedDate = ""
					this.globalObject.transporter = ""
					this.globalObject.expiryDate = ""
					this.globalObject.isThreshold = false
					this.globalObject.thresholdValue = 0
				} else {
					this.globalObject.orderID = ""
					document.getElementById('orderID').value = ""
					this.$alert(result.data.msg, orderID)
				}
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		},

		async updateOrderIdRVPGRN() {
			try {
				if(this.globalObject.orderID.trim() == this.updatedOrderId.trim()){
					this.$alert(this.$t('createGRN.cantUpdateSameOrder'))
					return false;
				}
				if(this.isOrderIdUpdated){
					this.$alert(this.$t('createGRN.cantUpdateOrder'))
					return false;
				}
				if (!this.updatedOrderId) {
					this.$alert(this.$t('common.orderIDPlaceholder'))
					return false;
				}
				const orderID = this.updatedOrderId
				this.isLoading1 = true
				const inputPayload = {
					clientid: this.client,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					orderid: this.updatedOrderId.trim()
				}
				const result = await rtoApis.validateOrderIdForSRGRC(this.token, inputPayload)
				if (result.data.errorCode == 0) {
					if (result.data.srcount >= 1) {
						this.$alert(this.$t('createGRN.rvpAlreadyMarked'))
					}
					const updatePayload = {
						srid: this.globalObject.srId,
						clientid: localStorage.getItem("selectedClient"),
						warehouseid: localStorage.getItem('selectedClient'),
						useremail: this.globalObject.userEmail,
						orderid: this.globalObject.orderID.trim(),
						updatedorderid: this.updatedOrderId.trim(),
						awbno: this.globalObject.awbNo.trim(),
					}
					const updateResult = await rtoApis.updateOrderIdRVPGRN(this.token, updatePayload)
					if(updateResult.data.errorCode == 0){
						this.showOrderIdInput = false
						this.isValidAWB = true
						this.isOrderIdUpdated = true
						this.scanAwbNo()
					}
					this.isLoading1 = false
				} else {
					this.isLoading1 = false
					this.updatedOrderId = ""
					document.getElementById('updatedOrderID').value = ""
					this.$alert(result.data.msg, orderID)
				}
			} catch (err) {
				this.isLoading1 = false
				console.log(err)
				this.closeAllLoader()
			}
		},

		resetProduct() {
			this.drData.invReferenceID = ""
			this.drData.mrp = ""
			this.drData.expiryDate = ""
			this.globalObject.productId = ""
			this.uploadPictures = false
			this.imageRefId = ""
			this.cameraSection = false
			this.fileSection = false
			this.file = null
			this.cameraImage = null
			this.showQCButton = false
			this.isProductReject = false
			this.globalObject.rejectReason = ""
			this.globalObject.expiryDate = ""
			this.globalObject.isThreshold = false
			this.globalObject.thresholdValue = 0
			this.globalObject.scanProductDetails.productid = ""
			this.globalObject.scanProductDetails.clientproductid = ""
			this.globalObject.scanProductDetails.productname = ""
			this.globalObject.scanProductDetails.productdescription = ""
			this.globalObject.scanProductDetails.productimage = ""
			this.globalObject.scanProductDetails.productType = ""
			this.globalObject.scanProductDetails.expirycontrolled = ""
			this.globalObject.scanProductDetails.nocontrol = ""
			this.productUploadLabel = false
			this.productUploadImage1 = false
			this.productUploadImage2 = false
			this.productUploadImage3 = false
			this.imageCaptured = false
			this.imageType = ""
			this.productUploadLabelUpload = false
			this.productUploadImage1Upload = false
			this.productUploadImage2Upload = false
			this.productUploadImage3Upload = false
			this.productUploadLabelUrl = ""
			this.productUploadImage1Url = ""
			this.productUploadImage2Url = ""
			this.productUploadImage3Url = ""
			this.qcDoneReject = false
			this.viewImage = false
			this.imageUrl = ""
			this.showExpiryDate = false
			document.getElementById('productId').disabled = false
			document.getElementById('productId').value = null
		},

		async scanProduct() {
			try {
				if (!this.globalObject.productId) {
					this.$alert(this.$t('common.productIdPlaceHolder'))
					return false
				}
				this.viewImage = false
				this.imageUrl = ""
				this.imageDescription = ""
				this.drData.invReferenceID = ""
				this.drData.mrp = ""
				this.drData.expiryDate = ""
				this.uploadPictures = false
				this.imageRefId = ""
				this.cameraSection = false
				this.fileSection = false
				this.file = null
				this.cameraImage = null
				this.showQCButton = false
				this.isProductReject = false
				this.globalObject.rejectReason = ""
				this.globalObject.scanProductDetails.productid = ""
				this.globalObject.scanProductDetails.clientproductid = ""
				this.globalObject.scanProductDetails.productname = ""
				this.globalObject.scanProductDetails.productdescription = ""
				this.globalObject.scanProductDetails.productimage = ""
				this.globalObject.scanProductDetails.productType = ""
				this.globalObject.scanProductDetails.expirycontrolled = ""
				this.globalObject.scanProductDetails.nocontrol = ""
				this.productUploadLabel = false
				this.productUploadImage1 = false
				this.productUploadImage2 = false
				this.productUploadImage3 = false
				this.imageCaptured = false
				this.imageType = ""
				this.productUploadLabelUpload = false
				this.productUploadImage1Upload = false
				this.productUploadImage2Upload = false
				this.productUploadImage3Upload = false
				this.productUploadLabelUrl = ""
				this.productUploadImage1Url = ""
				this.productUploadImage2Url = ""
				this.productUploadImage3Url = ""
				this.globalObject.isThreshold = false
				this.globalObject.thresholdValue = 0
				this.qcDoneReject = false
				if (this.isRTO) {
					this.isLoading3 = true
					let inputPayload = {
						clientid: localStorage.getItem("selectedClient"),
						warehouseid: localStorage.getItem("selectedWarehouse"),
						awbno: this.globalObject.awbNo,
						rtoid: this.globalObject.rtoId,
						productid: this.globalObject.productId.trim(),
						orderid: this.globalObject.orderID
					}
					let result = await rtoApis.validateProuctGRCRTO(this.token, inputPayload)
					this.isLoading3 = false
					let productId = this.globalObject.productId
					if (result.data.errorCode == 0) {
						let data = result.data.data
						if(data.isrefurbished=='yes'){
                            this.showrefurbished = true;
						}else{
							this.showrefurbished = false;
						}
						document.getElementById('productId').disabled = true
						if (data.isnop != 1) {
							this.showQCButton = true
						}
						if (data.isexcess > 0 || data.isextra > 0 || data.isnop > 0) {
							if (data.isexcess > 0) {
								this.globalObject.scanProductDetails.productType = "Excess"
							} else if (data.isextra > 0) {
								this.globalObject.scanProductDetails.productType = "Extra"
							} else {
								this.globalObject.scanProductDetails.productType = "NOP"
							}
							this.$alert(result.data.msg, productId)
						} else {
							this.globalObject.scanProductDetails.productType = "Normal"
						}
						if (this.globalObject.scanProductDetails.productType == "NOP") {
							this.globalObject.scanProductDetails.productid = this.globalObject.productId
						} else {
							this.globalObject.scanProductDetails.productid = data.productdata.productid
						}
						this.globalObject.scanProductDetails.clientproductid = data.productdata.clientproductid
						this.globalObject.scanProductDetails.productname = data.productdata.productname
						this.globalObject.scanProductDetails.productdescription = data.productdata.productdescription
						this.globalObject.scanProductDetails.productimage = data.productdata.productimage
						this.globalObject.scanProductDetails.expirycontrolled = data.productdata.expirycontrolled
						this.globalObject.scanProductDetails.nocontrol = data.productdata.nocontrol
						this.globalObject.isThreshold = data.isThreshold
						this.globalObject.thresholdValue = Number(data.thresholdValue)
						if (parseInt(this.globalObject.scanProductDetails.expirycontrolled) == 1 && parseInt(this.globalObject.scanProductDetails.nocontrol) == 1) {
							this.showQCButton = false;
							this.showExpiryDate = true;
						} else {
							this.showQCButton = true;
							this.showExpiryDate = false;
						}
					} else {
						this.globalObject.productId = ""
						document.getElementById('productId').value = null
						this.$alert(result.data.msg, productId)
					}
				} else {
					this.isLoading3 = true
					let inputPayload = {
						clientid: this.client,
						warehouseid: localStorage.getItem("selectedWarehouse"),
						productid: this.globalObject.productId.trim(),
						orderid: this.globalObject.orderID,
						srid: this.globalObject.srId,
						isinitiated: this.isInitiated
					}
					let result = await rtoApis.validateProductForSRGRC(this.token, inputPayload)
					this.isLoading3 = false
					let productId = this.globalObject.productId
					if (result.data.errorCode == 0) {
						let data = result.data.data
						if(data.isrefurbished=='yes'){
                            this.showrefurbished = true;
						}else{
							this.showrefurbished = false;
						}
						document.getElementById('productId').disabled = true
						if (data.isnop != 1) {
							this.showQCButton = true
						}
						if (data.isexcess > 0 || data.isextra > 0 || data.isnop > 0) {
							if (data.isexcess > 0) {
								this.globalObject.scanProductDetails.productType = "Excess"
							} else if (data.isextra > 0) {
								this.globalObject.scanProductDetails.productType = "Extra"
							} else {
								this.globalObject.scanProductDetails.productType = "NOP"
							}
							this.$alert(result.data.msg, productId)
						} else {
							this.globalObject.scanProductDetails.productType = "Normal"
						}
						if (this.globalObject.scanProductDetails.productType == "NOP") {
							this.globalObject.scanProductDetails.productid = this.globalObject.productId
						} else {
							this.globalObject.scanProductDetails.productid = data.productdata.productid
						}
						this.globalObject.scanProductDetails.clientproductid = data.productdata.eancode
						this.globalObject.scanProductDetails.productname = data.productdata.productname
						this.globalObject.scanProductDetails.productdescription = data.productdata.productname
						this.globalObject.scanProductDetails.productimage = data.productdata.productimage
						this.globalObject.scanProductDetails.expirycontrolled = data.productdata.expirycontrolled
						this.globalObject.scanProductDetails.nocontrol = data.productdata.nocontrol
						this.globalObject.isThreshold = data.isThreshold
						this.globalObject.thresholdValue = Number(data.thresholdValue)
						if (parseInt(this.globalObject.scanProductDetails.expirycontrolled) == 1 && parseInt(this.globalObject.scanProductDetails.nocontrol) == 1) {
							this.showQCButton = false;
							this.showExpiryDate = true;
						} else {
							this.showQCButton = true;
							this.showExpiryDate = false;
						}
						this.drData.invReferenceID = data.drData[0].invreferenceid
						this.drData.mrp = data.drData[0].mrp
						this.drData.expiryDate = data.drData[0].expirydate && data.drData[0].expirydate != null ? data.drData[0].expirydate : ""
					} else {
						this.globalObject.productId = ""
						document.getElementById('productId').value = null
						this.$alert(result.data.msg, productId)
					}

				}
				Vue.nextTick(() => {
					this.isRefurbished=false;
					this.isBoxchanged=false;
					document.getElementById('isRefurbished1').checked = false
					document.getElementById('boxchange1').checked = false
				})
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		},

		async showQCButtonsForGrn() {
			this.showQCButton = true;
			Vue.nextTick(() => {
				this.isRefurbished=false;
				this.isBoxchanged=false;
				document.getElementById('isRefurbished1').checked = false
				document.getElementById('boxchange1').checked = false

			})
		},

		async nopFound() {
			try {
				if (this.imageDescription == "") {
					this.$alert("Image description is required for NOP product")
					return false
				}
				let rtoID = 0
				let srID = 0
				if (this.isRTO) {
					rtoID = this.globalObject.rtoId
				} else {
					srID = this.globalObject.srId
				}
				let inputPayload = {
					clientid: this.client,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					awbno: this.globalObject.awbNo,
					rtoid: rtoID,
					srid: srID,
					createdby: this.globalObject.userEmail,
					rejectreason: this.globalObject.rejectReason,
					productid: this.globalObject.scanProductDetails.productid,
					producttype: this.globalObject.scanProductDetails.productType,
					imagedescription: this.imageDescription
				}
				this.isLoading3 = true
				let result = await rtoApis.getImageEntry(this.token, inputPayload)
				this.isLoading3 = false
				if (result.data.errorCode == 0) {
					this.uploadPictures = true
					this.imageRefId = result.data.id
					this.$alert("Upload product images")
				} else {
					this.$alert(result.data.msg)
				}
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		},

		productQC(obj) {
			if (obj == 'accept') {
				this.completeProductQC(obj)
			} else {
				this.isProductReject = true
			}
		},

		async completeProductQC(obj) {
			try {
				this.imageCaptured = false
				this.imageRefId = ""
				this.cameraSection = false
				this.fileSection = false
				this.file = null
				this.cameraImage = null
				this.imageType = ""
				if (obj == "reject" && this.globalObject.rejectReason == "") {
					this.$alert(this.$t("boxList.reasonPlaceholder"))
					return false
				}
				if (obj == "reject") {
					let rtoID = 0
					let srID = 0
					if (this.isRTO) {
						rtoID = this.globalObject.rtoId
					} else {
						srID = this.globalObject.srId
					}
					let imagedescription = ""
					if (this.globalObject.scanProductDetails.productType == "NOP") {
						imagedescription = this.imageDescription
					} else {
						imagedescription = this.globalObject.rejectReason
					}
					let inputPayload = {
						clientid: this.client,
						warehouseid: localStorage.getItem("selectedWarehouse"),
						awbno: this.globalObject.awbNo,
						rtoid: rtoID,
						srid: srID,
						createdby: this.globalObject.userEmail,
						rejectreason: this.globalObject.rejectReason,
						productid: this.globalObject.scanProductDetails.productid,
						producttype: this.globalObject.scanProductDetails.productType,
						imagedescription: this.imageDescription
					}
					this.isLoading3 = true
					let result = await rtoApis.getImageEntry(this.token, inputPayload)
					this.isLoading3 = false
					if (result.data.errorCode == 0) {
						this.uploadPictures = true
						this.imageRefId = result.data.id
						this.$alert(this.$t("productLogReport.uploadImages"))
					} else {
						this.$alert(result.data.msg)
					}
				} else {
					if (this.isRTO) {

						if (this.globalObject.isThreshold) {
							const currentDate = new Date()
							currentDate.setDate(currentDate.getDate() + this.globalObject.thresholdValue);
							const productExpiryDate = new Date(this.dateFormat(this.globalObject.expiryDate))

							// const diffTime = Math.abs(productExpiryDate - currentDate)
							// const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
							if (productExpiryDate < currentDate) {
								//const minExpiryDate = new Date()
								//minExpiryDate.setDate(currentDate.getDate() + (this.globalObject.thresholdValue))
								this.$alert("Mark this product as reject . Min Expiry date should be  " + currentDate)
								return false
							}
						}
						let inputPayload = {
							clientid: this.client,
							warehouseid: localStorage.getItem("selectedWarehouse"),
							awbno: this.globalObject.awbNo,
							rtoid: this.globalObject.rtoId,
							orderid: this.globalObject.orderID,
							couriername: this.globalObject.transporter,
							productid: this.globalObject.scanProductDetails.productid,
							productType: "Accept",
							rejectReason: this.globalObject.rejectReason,
							productCategory: this.globalObject.scanProductDetails.productType,
							useremail: this.globalObject.userEmail,
							rejectImageid: this.imageRefId,
							expirydate: this.dateFormat(this.globalObject.expiryDate),
							isBoxchanged: this.isBoxchanged == true ? 1 : 0
						}
						this.isLoading2 = true
						this.isLoading3 = true
						this.isLoading4 = true
						this.isLoading5 = true
						let result = await rtoApis.qcRTO(this.token, inputPayload)
						this.isLoading2 = false
						this.isLoading3 = false
						this.isLoading4 = false
						this.isLoading5 = false
						if (result.data.errorCode == 0) {
							let data = result.data.data
							this.globalObject.productDetails = []
							data.rtodata.forEach((el) => {
								this.globalObject.productDetails.push({
									productid: el.productid,
									quantity: el.quantity,
									productname: el.productname,
									eancode: el.eancode,
									status: el.status,
									productqty: el.productqty,
									total_quantity: Number(el.accepted_qty) + Number(el.rejected_qty),
									accepted_qty: el.accepted_qty,
									rejected_qty: el.rejected_qty
								})
							})
							this.globalObject.productDetailsCount = data.rtodata[0].productqty
							this.globalObject.extraProductDetails = data.extraProduct
							this.globalObject.externalProductDetails = data.excessProduct
							this.qcDoneFlag = data.qcdoneflag
							this.globalObject.extraProductDetailsCount = 0
							this.globalObject.extraProductDetails.forEach((el) => {
								this.globalObject.extraProductDetailsCount = this.globalObject.extraProductDetailsCount + Number(el.total_qty)
							})
							this.globalObject.externalProductDetailsCount = 0
							this.globalObject.externalProductDetails.forEach((el) => {
								this.globalObject.externalProductDetailsCount = this.globalObject.externalProductDetailsCount + Number(el.total_qty)
							})
							this.imageRefId = ""
							this.cameraSection = false
							this.fileSection = false
							this.file = null
							this.cameraImage = null
							this.showQCButton = false
							this.isProductReject = false
							this.showExpiryDate = false
							this.globalObject.rejectReason = ""
							this.globalObject.productId = ""
							this.globalObject.expiryDate = ""
							this.globalObject.isThreshold = false
							this.globalObject.thresholdValue = 0
							this.globalObject.scanProductDetails.productid = ""
							this.globalObject.scanProductDetails.clientproductid = ""
							this.globalObject.scanProductDetails.productname = ""
							this.globalObject.scanProductDetails.productdescription = ""
							this.globalObject.scanProductDetails.productimage = ""
							this.globalObject.scanProductDetails.productType = ""
							this.globalObject.scanProductDetails.expirycontrolled = ""
							this.globalObject.scanProductDetails.nocontrol = ""
							this.productUploadLabel = false
							this.productUploadImage1 = false
							this.productUploadImage2 = false
							this.productUploadImage3 = false
							this.imageCaptured = false
							this.imageType = ""
							document.getElementById('productId').disabled = false
							document.getElementById('productId').value = null
							this.$alertify.success(result.data.msg)
							this.resetProduct()
						} else {
							this.$alert(result.data.msg)
							return false
						}
					} else {
						if (this.globalObject.isThreshold) {
							const currentDate = new Date()
							currentDate.setDate(currentDate.getDate() + this.globalObject.thresholdValue);
							const productExpiryDate = new Date(this.dateFormat(this.globalObject.expiryDate))

							// const diffTime = Math.abs(productExpiryDate - currentDate)
							// const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
							if (productExpiryDate < currentDate) {
								//const minExpiryDate = new Date()
								//minExpiryDate.setDate(currentDate.getDate() + (this.globalObject.thresholdValue))
								this.$alert("Mark this product as reject . Min Expiry date should be  " + currentDate)
								return false
							}
						}
						let inputPayload = {
							clientid: this.client,
							warehouseid: localStorage.getItem("selectedWarehouse"),
							awbno: this.globalObject.awbNo,
							srid: this.globalObject.srId,
							orderid: this.globalObject.orderID,
							productid: this.globalObject.scanProductDetails.productid,
							productType: "Accept",
							productCategory: this.globalObject.scanProductDetails.productType,
							useremail: this.globalObject.userEmail,
							expirydate: this.dateFormat(this.globalObject.expiryDate),
							isinitiated: this.isInitiated,
							invreferenceid: this.drData.invReferenceID,
							mrp: this.drData.mrp,
							rejectImageid: this.imageRefId,
							isBoxchanged:this.isBoxchanged = this.isBoxchanged == true ? 1 : 0
						}
						this.isLoading2 = true
						this.isLoading3 = true
						this.isLoading4 = true
						this.isLoading5 = true
						let result = await rtoApis.saveSRGRC(this.token, inputPayload)
						this.isLoading2 = false
						this.isLoading3 = false
						this.isLoading4 = false
						this.isLoading5 = false
						if (result.data.errorCode == 0) {
							if(!this.isOrderIdUpdated && this.isInitiated > 0){
								await rtoApis.updateOrderIdFlagSRReturn(this.token, {clientid: localStorage.getItem("selectedClient"), srid: this.globalObject.srId})
								this.isOrderIdUpdated = true
							}
							let data = result.data.data
							this.globalObject.productDetails = []
							data.srdata.forEach((el) => {
								this.globalObject.productDetails.push({
									productid: el.productid,
									quantity: el.productqty,
									productname: el.productname,
									eancode: el.eancode,
									productqty: el.productqty,
									total_quantity: Number(el.accepted_qty) + Number(el.rejected_qty),
									accepted_qty: el.accepted_qty,
									rejected_qty: el.rejected_qty
								})
							})
							this.globalObject.productDetailsCount = 0
							this.globalObject.productDetails.forEach((el) => {
								this.globalObject.productDetailsCount = this.globalObject.productDetailsCount + Number(el.productqty)
							})
							this.globalObject.extraProductDetails = data.extraProduct
							this.globalObject.externalProductDetails = data.excessProduct
							this.qcDoneFlag = data.qcdoneflag
							this.globalObject.extraProductDetailsCount = 0
							this.globalObject.extraProductDetails.forEach((el) => {
								this.globalObject.extraProductDetailsCount = this.globalObject.extraProductDetailsCount + Number(el.total_qty)
							})
							this.globalObject.externalProductDetailsCount = 0
							this.globalObject.externalProductDetails.forEach((el) => {
								this.globalObject.externalProductDetailsCount = this.globalObject.externalProductDetailsCount + Number(el.total_qty)
							})
							this.imageRefId = ""
							this.cameraSection = false
							this.fileSection = false
							this.file = null
							this.cameraImage = null
							this.showQCButton = false
							this.isProductReject = false
							this.globalObject.rejectReason == ""
							this.globalObject.productId == ""
							this.globalObject.scanProductDetails.productid = ""
							this.globalObject.scanProductDetails.clientproductid = ""
							this.globalObject.scanProductDetails.productname = ""
							this.globalObject.scanProductDetails.productdescription = ""
							this.globalObject.scanProductDetails.productimage = ""
							this.globalObject.scanProductDetails.productType = ""
							this.globalObject.scanProductDetails.expirycontrolled = ""
							this.globalObject.scanProductDetails.nocontrol = ""
							this.productUploadLabel = false
							this.productUploadImage1 = false
							this.productUploadImage2 = false
							this.productUploadImage3 = false
							this.imageCaptured = false
							this.imageType = ""
							this.drData.expiryDate = ""
							this.drData.invReferenceID = ""
							this.drData.mrp = ""
							this.globalObject.expiryDate = ""
							this.globalObject.isThreshold = false
							this.globalObject.thresholdValue = 0
							this.showExpiryDate = false
							document.getElementById('productId').disabled = false
							document.getElementById('productId').value = null
							if(this.globalObject.expiryDate){
								document.getElementById('expirydate').value = null
							}
							this.$alertify.success(result.data.msg)
							this.resetProduct()
						} else {
							this.$alert(result.data.msg)
							return false
						}
					}
				}
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		},

		checkCloseGR() {
			if (this.globalObject.productId != "") {
				this.$alert(this.$t('rtoGrn.completeQcError'))
				return false
			}
			let msg = 'Continue to close GR ?'

			if (!this.qcDoneFlag) {
				msg = 'Items whose grc not done will be marked as short , Continue to close GR ?'
			}
			this.$confirm(msg).then((confirm) => {
				if (confirm) {
					this.closeGR()
				}
			})
		},

		async closeGR() {
			try {
				if (this.isRTO) {
					let inputPayload = {
						rtoid: this.globalObject.rtoId,
						clientid: this.client,
						warehouseid: localStorage.getItem("selectedWarehouse"),
						awbno: this.globalObject.awbNo,
						couriername: this.globalObject.transporter,
						useremail: this.globalObject.userEmail
					}
					this.isLoading6 = true
					let result = await rtoApis.closeRTOGR(this.token, inputPayload)
					this.isLoading6 = false
					if (result.data.errorCode == 0) {
						this.$alertify.success(result.data.msg)
						this.resetForm()
					} else {
						this.$alert(result.data.msg)
						return false
					}
				} else {
					let inputPayload = {
						srid: this.globalObject.srId,
						clientid: this.client,
						warehouseid: localStorage.getItem("selectedWarehouse"),
						useremail: this.globalObject.userEmail,
						isinitiated: this.isInitiated
					}
					this.isLoading6 = true
					let result = await rtoApis.closeGRCSR(this.token, inputPayload)
					this.isLoading6 = false
					if (result.data.errorCode == 0) {
						this.$alertify.success(result.data.msg)
						this.resetForm()
					} else {
						this.$alert(result.data.msg)
						return false
					}
				}
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		},

		uploadImage(imagetype, uploadType) {
			this.imageType = imagetype
			this.cameraSection = true
			this.file = null
			this.cameraImage = null
			if (uploadType == 'camera') {
				this.fileSection = false
			} else {
				this.fileSection = true
			}
		},

		captureImage() {
			this.$refs.cameraImage.pause()
			this.imageCaptured = true
		},

		resetImage() {
			this.imageCaptured = false
			this.$refs.cameraImage.resume()
		},

		async saveImage(imagetype, inputtype) {
			try {
				if (!this.imageCaptured && inputtype == 'camera') {
					this.$alert("Capture image")
					return false
				} else if (!this.file && inputtype == 'file') {
					this.$alert("Select image")
					return false
				}
				this.isLoading7 = true
				let imageString = ""
				if (inputtype == "camera") {
					imageString = this.$refs.cameraImage.capture()
				} else {
					let reader = new FileReader()
					reader.readAsDataURL(this.file)
					imageString = await new Promise((resolve, reject) => {
						reader.onload = function () {
							this.base64String = reader.result.replace("", "")
							resolve(this.base64String)
						}
					})
				}
				if (!common_helper.calculateImageSize(imageString)) {
					this.$alert("please add image less than 4 MB")
					this.isLoading7 = false
					imageString = ""
					document.getElementById('file').value = null
					return false
				}
				let inputPayload = {
					clientid: this.client,
					id: this.imageRefId,
					imagetype: this.imageType,
					imagestring: imageString,
					producttype: this.globalObject.scanProductDetails.productType,
					orderid:this.globalObject.orderID,
				}
				let result = await rtoApis.addImageEntry(this.token, inputPayload)
				this.isLoading7 = false
				if (result.data.data.errorCode == 0) {
					this.imageCaptured = false
					this.cameraSection = false
					this.fileSection = false
					this.file = null
					this.cameraImage = null
					if (imagetype == 'label') {
						this.productUploadLabel = true
						this.productUploadLabelUpload = true
						this.productUploadLabelUrl = result.data.presignurl
					} else if (imagetype == 'image1') {
						this.productUploadImage1 = true
						this.productUploadImage1Upload = true
						this.productUploadImage1Url = result.data.presignurl
					} else if (imagetype == 'image2') {
						this.productUploadImage2 = true
						this.productUploadImage2Upload = true
						this.productUploadImage2Url = result.data.presignurl
					} else {
						this.productUploadImage3 = true
						this.productUploadImage3Upload = true
						this.productUploadImage3Url = result.data.presignurl
					}
					this.$alertify.success(result.data.data.msg)
					this.checkAllImagesUploaded('Reject')
				} else {
					this.$alert(result.data.data.msg)
					return false
				}
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		},

		async checkAllImagesUploaded(obj) {
			try {
				if (this.productUploadLabel && this.productUploadImage1 && this.productUploadImage2 && this.productUploadImage3 && this.globalObject.scanProductDetails.productType != "NOP") {
					if (this.isRTO && !this.qcDoneReject) {
						let inputPayload = {
							clientid: this.client,
							warehouseid: localStorage.getItem("selectedWarehouse"),
							awbno: this.globalObject.awbNo,
							rtoid: this.globalObject.rtoId,
							orderid: this.globalObject.orderID,
							couriername: this.globalObject.transporter,
							productid: this.globalObject.scanProductDetails.productid,
							productType: obj,
							rejectReason: this.globalObject.rejectReason,
							productCategory: this.globalObject.scanProductDetails.productType,
							useremail: this.globalObject.userEmail,
							rejectImageid: this.imageRefId,
							expirydate: this.dateFormat(this.globalObject.expiryDate),
							isRefurbished:this.isRefurbished == true ? 1 : 0,
							isBoxchanged:this.isBoxchanged == true ? 1 : 0
						}
						this.isLoading2 = true
						this.isLoading3 = true
						this.isLoading4 = true
						this.isLoading5 = true
						let result = await rtoApis.qcRTO(this.token, inputPayload)
						this.isLoading2 = false
						this.isLoading3 = false
						this.isLoading4 = false
						this.isLoading5 = false
						if (result.data.errorCode == 0) {
							this.qcDoneReject = true
							let data = result.data.data
							this.globalObject.productDetails = []
							data.rtodata.forEach((el) => {
								this.globalObject.productDetails.push({
									productid: el.productid,
									quantity: el.quantity,
									productname: el.productname,
									eancode: el.eancode,
									status: el.status,
									productqty: el.productqty,
									total_quantity: Number(el.accepted_qty) + Number(el.rejected_qty),
									accepted_qty: el.accepted_qty,
									rejected_qty: el.rejected_qty
								})
							})
							this.globalObject.productDetailsCount = data.rtodata[0].productqty
							this.globalObject.extraProductDetails = data.extraProduct
							this.globalObject.externalProductDetails = data.excessProduct
							this.qcDoneFlag = data.qcdoneflag
							this.globalObject.extraProductDetailsCount = 0
							this.globalObject.extraProductDetails.forEach((el) => {
								this.globalObject.extraProductDetailsCount = this.globalObject.extraProductDetailsCount + Number(el.total_qty)
							})
							this.globalObject.externalProductDetailsCount = 0
							this.globalObject.externalProductDetails.forEach((el) => {
								this.globalObject.externalProductDetailsCount = this.globalObject.externalProductDetailsCount + Number(el.total_qty)
							})
							this.cameraSection = false
							this.fileSection = false
							this.file = null
							this.cameraImage = null
							this.isProductReject = false
							this.globalObject.rejectReason == ""
							this.productUploadLabel = false
							this.productUploadImage1 = false
							this.productUploadImage2 = false
							this.productUploadImage3 = false
							this.imageCaptured = false
							this.globalObject.expiryDate = ""
							this.globalObject.isThreshold = false
							this.globalObject.thresholdValue = 0
							this.$alert(result.data.msg)
						} else {
							this.$alert(result.data.msg)
							return false
						}
					} else if (!this.qcDoneReject) {
						let inputPayload = {
							clientid: this.client,
							warehouseid: localStorage.getItem("selectedWarehouse"),
							awbno: this.globalObject.awbNo,
							srid: this.globalObject.srId,
							orderid: this.globalObject.orderID,
							productid: this.globalObject.scanProductDetails.productid,
							productType: obj,
							productCategory: this.globalObject.scanProductDetails.productType,
							useremail: this.globalObject.userEmail,
							expirydate: this.dateFormat(this.globalObject.expiryDate),
							isinitiated: this.isInitiated,
							invreferenceid: this.drData.invReferenceID,
							mrp: this.drData.mrp,
							rejectImageid: this.imageRefId,
							isRefurbished: this.isRefurbished == true ? 1 : 0,
							isBoxchanged:this.isBoxchanged == true ? 1 : 0
						}
						this.isLoading2 = true
						this.isLoading3 = true
						this.isLoading4 = true
						this.isLoading5 = true
						let result = await rtoApis.saveSRGRC(this.token, inputPayload)
						this.isLoading2 = false
						this.isLoading3 = false
						this.isLoading4 = false
						this.isLoading5 = false
						if (result.data.errorCode == 0) {
							if(!this.isOrderIdUpdated && this.isInitiated > 0){
								await rtoApis.updateOrderIdFlagSRReturn(this.token, {clientid: localStorage.getItem("selectedClient"), srid: this.globalObject.srId})
								this.isOrderIdUpdated = true
							}
							this.qcDoneReject = true
							let data = result.data.data
							this.globalObject.productDetails = []
							data.srdata.forEach((el) => {
								this.globalObject.productDetails.push({
									productid: el.productid,
									quantity: el.productqty,
									productname: el.productname,
									eancode: el.eancode,
									productqty: el.productqty,
									total_quantity: Number(el.accepted_qty) + Number(el.rejected_qty),
									accepted_qty: el.accepted_qty,
									rejected_qty: el.rejected_qty
								})
							})
							this.globalObject.productDetailsCount = 0
							this.globalObject.productDetails.forEach((el) => {
								this.globalObject.productDetailsCount = this.globalObject.productDetailsCount + Number(el.productqty)
							})
							this.globalObject.extraProductDetails = data.extraProduct
							this.globalObject.externalProductDetails = data.excessProduct
							this.qcDoneFlag = data.qcdoneflag
							this.globalObject.extraProductDetailsCount = 0
							this.globalObject.extraProductDetails.forEach((el) => {
								this.globalObject.extraProductDetailsCount = this.globalObject.extraProductDetailsCount + Number(el.total_qty)
							})
							this.globalObject.externalProductDetailsCount = 0
							this.globalObject.externalProductDetails.forEach((el) => {
								this.globalObject.externalProductDetailsCount = this.globalObject.externalProductDetailsCount + Number(el.total_qty)
							})
							this.cameraSection = false
							this.fileSection = false
							this.file = null
							this.cameraImage = null
							this.imageCaptured = false
							this.drData.expiryDate = ""
							this.globalObject.expiryDate = ""
							this.globalObject.expiryDate = ""
							this.globalObject.isThreshold = false
							this.globalObject.thresholdValue = 0
							this.drData.invReferenceID = ""
							this.drData.mrp = ""
							this.$alert(result.data.msg)
						} else {
							this.$alert(result.data.msg)
							return false
						}
					}
				} else if (this.productUploadLabel && this.productUploadImage1 && this.productUploadImage2 && this.productUploadImage3 && this.globalObject.scanProductDetails.productType == "NOP") {
					this.cameraSection = false
					this.fileSection = false
					this.file = null
					this.cameraImage = null
					this.isProductReject = false
					this.globalObject.rejectReason == ""
					this.imageCaptured = false
					this.drData.expiryDate = ""
					this.globalObject.isThreshold = false
					this.globalObject.thresholdValue = 0
					this.drData.invReferenceID = ""
					this.drData.mrp = ""
					this.$alert("Product marked as NOP")
				}
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		},

		handleFileUpload() {
			this.file = this.$refs.file.files[0];
			let imageTypes = ['image/jpeg', 'image/png']
			let imageFormat = this.file.type
			let checkFormat = imageTypes.includes(imageFormat)
			if (!checkFormat) {
				this.file = null
				document.getElementById('file').value = null
				this.$alert("Invalid image format")
			}
		},

		async printLabelNop() {
			try {
				let inputPayload = {
					clientid: localStorage.getItem("selectedClient"),
					productid: this.globalObject.scanProductDetails.productid,
					mrp: 0.0,
					qty: 1
				}
				this.isLoading3 = true
				await rtoApis.printLabelNOP(this.token, inputPayload)
				this.isLoading3 = false
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		},

		viewImageUpload(obj, url) {
			if (obj == 1) {
				this.$alert("Image not uploaded")
			} else {
				this.viewImage = true
				this.imageUrl = url
			}
		},

		printLabelNopPDF() {
			try {
				this.isLoading3 = true
				setTimeout(function () {
					this.isLoading3 = false
					const newPrint = new Printd()
					var cssText = `
		         body{
		        -webkit-print-color-adjust:exact;
		      }
		         table {
		             border-collapse: collapse;
		             margin-left:0px !important;
		         }

		         table, td, th {
		           border-style: solid;
		      border-width: 1px;

		      margin-bottom: 10px;
		      border-color: rgba(0,0,255,0.25);
		             padding:4px;
		         }
		       pre {
		         color: #c7254e;
		       }
		       .text-right{
		         text-align:right;
		       }

		       @media print {
		       .text-primary th{
		         background-color:rgb(226, 216, 216) !important;
		         color:black !important;
		         font-size:20px !important;
		       }
		       @media print {
		       .text-primary tr{
		         background-color:rgb(226, 216, 216) !important;
		         color:black !important;
		         font-size:12px;
		         padding-left:5px;
		       }

		      }
		      `
					newPrint.print(document.getElementById('printNOPContent'), cssText);
				}.bind(this), 3000)
			} catch (err) {
				console.log(err)
				this.closeAllLoader()
			}
		}

	}
}



// WEBPACK FOOTER //
// ./src/views/components/rtogrn/rtogrn.component.js